/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 */
export default {
  // 租户规则拉取
  configList: {
    url: '/chat/configList',
    type: 'get'
  },
  // 聊天记录查询
  historyList: {
    url: '/chat/historyList',
    type: 'post'
  },
  // 更新已读状态
  updateHistoryStatus: {
    url: '/updateHistoryStatus',
    type: 'get'
  },
  // 背景图片生成
  createBackgroundImage: {
    url: '/chat/createBackgroundImage',
    type: 'get'
  },
  downloadFile: {
    url: '/file/download/auth',
    type: 'get'
  },
  downloadFileZip: {
    url: '/file/download/auth/zip',
    type: 'get'
  },
  selectUserGroupList: {
    url: '/chat/selectUserGroupList',
    type: 'post'
  },
  updateMsgStatus: {
    url: '/chat/updateMsgStatus',
    type: 'post'
  },
  checkImAuthority: {
    url: '/chat/checkImAuthority',
    type: 'post'
  }
}
